const report = {
  reportSb: 'Заключение СБ',
  reportHistory: 'История заключений',
  editReport: 'Редактирование заключения',
};

export default report;
